import { SyncOutlined } from '@ant-design/icons'
import { useQueryClient } from '@tanstack/react-query'
import { Input, Select, message } from 'antd'
import StyledLoader from 'components/Elements/StyledLoader'
import SectionTitle from 'components/SectionTitle'
import { Fragment, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router'
import axiosClient from 'services/axios-client'
import { useBookRoleQuery } from 'store/queries'
import { AddFriendsContainer } from './style'

const { Option } = Select

function AddFriends() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { bookId } = useParams()
  const history = useHistory()
  const [info, setInfo] = useState({})
  const [isUpdating, setIsUpdating] = useState(false)

  const { data: roleData } = useBookRoleQuery(bookId)
  const role = roleData?.name

  const roleOptions = {
    purchaser: [
      {
        value: 'editor',
        label: t('editor'),
      },
      {
        value: 'author',
        label: t('author'),
      },
      {
        value: 'reader',
        label: t('reader'),
      },
      {
        value: 'guest',
        label: t('per_story_prompt'),
      },
    ],
    editor: [
      {
        value: 'author',
        label: t('author'),
      },
      {
        value: 'reader',
        label: t('reader'),
      },
      {
        value: 'guest',
        label: t('per_story_prompt'),
      },
    ],
  }

  const onSendInvite = async () => {
    setIsUpdating(true)
    let postData = {
      ...info,
      book_id: parseInt(bookId),
      link: 'BOOK',
      role: info.role || 'reader',
      invite_type: 'initial',
    }

    const inviteResult = await axiosClient.post(
      `/book/${bookId}/sendInvite`,
      postData,
    )
    if (inviteResult.ok) {
      message.success(t('invite_send'))
      queryClient.invalidateQueries({ queryKey: ['book', bookId, 'users'] })
      setInfo({})
    } else {
      message.error(t('something_went_wrong'))
    }

    setIsUpdating(false)
    history.push(`/dashboard/book/${bookId}/friends/invites`)
  }

  if (!role) {
    return <StyledLoader />
  }
  return (
    <AddFriendsContainer>
      <div className="modal-invite section-container">
        <div className="modal-custom-body p20">
          <SectionTitle className="mb2rem">
            {role === 'Author' ? 'Add Reader' : t('invite_user')}
          </SectionTitle>
          <Input
            className="mb-3"
            placeholder={t('first_name')}
            value={info.first}
            onChange={(e) => setInfo({ ...info, first: e.target.value })}
          />
          <Input
            className="mb-3"
            placeholder={t('last_name')}
            value={info.last}
            onChange={(e) => setInfo({ ...info, last: e.target.value })}
          />
          <Input
            className="mb-3"
            placeholder={t('email')}
            value={info.email}
            onChange={(e) => setInfo({ ...info, email: e.target.value })}
          />
          {(role === 'Purchaser' || role === 'Editor') && (
            <Fragment>
              <Select
                style={{ width: '100%' }}
                className="mb-3"
                placeholder={t('role')}
                value={info.role}
                onChange={(value) => setInfo({ ...info, role: value })}
              >
                {roleOptions[role.toLowerCase()].map((_option, _i) => (
                  <Option key={_i} value={_option.value}>
                    {_option.label}
                  </Option>
                ))}
              </Select>
            </Fragment>
          )}
        </div>
        <div className="modal-custom-footer">
          <div className="btns-wrapper actions">
            <Button className="btn-blue btn-dash" onClick={onSendInvite}>
              {t('send_invite')}
            </Button>

            {isUpdating && (
              <div data-testid="add-friends-updating">
                <SyncOutlined spin />
              </div>
            )}
          </div>
        </div>
      </div>
    </AddFriendsContainer>
  )
}

export default AddFriends
